import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './Departments.css';

const DEPT_HERO = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1920&q=80';

const departments = [
  {id:'design',    number:'01', title:'Design Studio',   subtitle:'Where every product begins',
   img:'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=900&q=80',
   desc:'Our in-house design team converts your vision into technically precise artwork — from logo placement and color specs to full garment technical packs.',
   capabilities:['Technical drawing & flat sketches','Custom logo integration','Colorway development','Sample mockups','Print-ready files']},
  {id:'pattern',   number:'02', title:'Pattern Making',  subtitle:'Precision fit across all sizes',
   img:'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=900&q=80',
   desc:'Our pattern room drafts and grades patterns using international sizing tables, refined through fit samples and client feedback.',
   capabilities:['Flat pattern drafting','Multi-size grading','Fit sample adjustment','Digital digitizing','Size set sampling']},
  {id:'fabric',    number:'03', title:'Fabric Making',   subtitle:'In-house proprietary weaving',
   img:'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=900&q=80',
   desc:'We manufacture Pearl Weave, Gold Weave, Crystal Weave, Diamond Weave and Honey Comb fabrics in-house to precise GSM specs.',
   capabilities:['Pearl / Gold / Crystal Weave','Diamond & Chess Weave','Honey Comb Weave','350–750 GSM range','CVC & 100% cotton']},
  {id:'knitting',  number:'04', title:'Knitting',        subtitle:'Performance stretch fabrics',
   img:'https://images.unsplash.com/photo-1574634534894-89d7576c8259?auto=format&fit=crop&w=900&q=80',
   desc:'Our knitting unit produces stretch fabrics for rash guards, spats, compression shorts and sports bras.',
   capabilities:['Circular & flat knitting','Spandex & polyester blends','Custom GSM knits','Performance fabrics','Moisture-wicking']},
  {id:'dyeing',    number:'05', title:'Fabric Dyeing',   subtitle:'Color that holds',
   img:'https://images.unsplash.com/photo-15+92-342-075 7213-e957c6296406?auto=format&fit=crop&w=900&q=80',
   desc:'Jet dyeing machines achieve even saturation, colorfastness and consistent color matching across all production runs.',
   capabilities:['Jet dyeing machines','All martial arts colors','Custom Pantone matching','ISO wash fastness','Batch consistency']},
  {id:'cutting',   number:'06', title:'Cutting',         subtitle:'Material efficiency & accuracy',
   img:'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=900&q=80',
   desc:'Computerized spreading and cutting ensures panel accuracy and minimizes fabric waste.',
   capabilities:['Computer-aided cutting','Lay planning','Fabric utilization','Panel inspection','All fabric types']},
  {id:'stitching', number:'07', title:'Stitching',       subtitle:'Built to take punishment',
   img:'https://images.unsplash.com/photo-1585914924626-15adac1e6402?auto=format&fit=crop&w=900&q=80',
   desc:'Skilled machinists with heavy-duty industrial machines using triple stitching, bartacking and chain stitching.',
   capabilities:['Single & triple needle','Chain stitch & overlock','Bartack reinforcement','Heavy-duty machines','Gi specialists']},
  {id:'printing',  number:'08', title:'Printing',        subtitle:'Branding that stands out',
   img:'https://images.unsplash.com/photo-1562408590-e32931084e23?auto=format&fit=crop&w=900&q=80',
   desc:'Screen and sublimation printing in-house — screen for patches, sublimation for full-color performance designs.',
   capabilities:['Screen printing','Sublimation printing','Heat transfer','In-house embroidery','PVC patch printing']},
  {id:'inspection',number:'09', title:'Inspection & QC', subtitle:'Zero compromise on quality',
   img:'https://images.unsplash.com/photo-15+92-342-075 7213-35680f356dfd?auto=format&fit=crop&w=900&q=80',
   desc:'Every finished unit inspected against a multi-point quality checklist before packing.',
   capabilities:['Multi-point QC','Measurement check','Seam strength test','Color inspection','Pre-shipment check']},
  {id:'packing',   number:'10', title:'Packing & Export',subtitle:'Ready for the world',
   img:'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=900&q=80',
   desc:'Export-grade packing — polybag, hangtag, carton packing and full shipping documentation.',
   capabilities:['Polybag & box packaging','Custom hangtag','Export carton','Shipping docs','Logistics coordination']},
];

export default function Departments() {
  return (
    <div className="departments-page">

      <section className="page-hero dept-page-hero">
        <div className="dept-hero__img" style={{backgroundImage:`url(${DEPT_HERO})`}}/>
        <div className="dept-hero__overlay"/>
        <div className="container page-hero__content">
          <span className="section-label">Manufacturing</span>
          <h1 className="page-hero__title">Our Departments</h1>
          <p className="page-hero__sub">
            Every product goes through 10 specialized departments under one roof —
            complete quality control from raw material to finished export shipment.
          </p>
        </div>
        <div className="dept-hero__shape"/>
      </section>

      <section className="depts-section">
        <div className="container">
          {departments.map((dept,i)=>(
            <div key={dept.id} id={dept.id} className={`dept-row ${i%2!==0?'dept-row--reverse':''}`}>
              <div className="dept-row__visual">
                <img
                  src={dept.img} alt={dept.title}
                  className="dept-img" loading="lazy"
                  onError={e=>{e.target.style.display='none';}}
                />
                <div className="dept-img-overlay">
                  <div className="dept-img-label">
                    <span className="dept-img-number">{dept.number}</span>
                    <h3>{dept.title}</h3>
                    <p>{dept.subtitle}</p>
                  </div>
                </div>
              </div>
              <div className="dept-row__content">
                <div className="dept-row__badge">{dept.number}</div>
                <h2 className="dept-row__title">{dept.title}</h2>
                <p className="dept-row__subtitle">{dept.subtitle}</p>
                <div className="divider-gold"/>
                <p className="dept-row__desc">{dept.desc}</p>
                <div className="dept-capabilities">
                  <h4>Key Capabilities:</h4>
                  <ul>{dept.capabilities.map(cap=>(
                    <li key={cap}><FiArrowRight size={13} color="var(--gold)"/> {cap}</li>
                  ))}</ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="depts-cta">
        <div className="container depts-cta__inner">
          <h2>Interested in OEM or Private Label?</h2>
          <p>Full in-house manufacturing — concept to export, no third-party dependency.</p>
          <Link to="/contact" className="btn-primary">Talk to Our Team <FiArrowRight size={16}/></Link>
        </div>
      </section>
    </div>
  );
}